import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import useFontSize from '../../shell/hooks/useFontSize';

interface CreditProps {

}

export const Credit: React.FC<CreditProps> = ({ }) => {
    const styles = StyleSheet.create({
        container: {
            width: "100%",
            height: "100%",
            justifyContent: "center",
            alignItems: "center"

        },
        text: {

            fontSize: useFontSize(7),
            color: "white",

        }

    });
    return (
        <View style={styles.container}>
            <Text style={styles.text}>SOON...</Text>

        </View>
    );
};